<div class="modal-container">
  <div class="modal-header ">
    <h4 class="modal-title">Add a Note</h4>
    <button type="button" class="close" aria-label="Close" (click)="hideModal()">
      &times;
    </button>
  </div>
  <form #notesForm="ngForm" (ngSubmit)="notesForm.valid && handleAddNotes()">
    <div class="modal-body admin-list" *ngIf="notes">
      <div class="row">
        <div class="col-6 mb-3">
          <div class="form-group">
            <label>Source*</label>
            <select required class="form-control" name="contactType" [(ngModel)]="notes.source_type">
              <option value="1">Chat</option>
              <option value="2">CallBack Request</option>
              <option value="3">Email</option>
              <option value="4">Payment Alert</option>
              <option value="5">Missed Call</option>
              <option value="6">New User</option>
              <option value="7">Expert Assist</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Assignment Type*</label>
            <select class="form-control" name="contactResult" required [(ngModel)]="notes.contact_request_type">
              <option value="1">New Lead</option>
              <option value="2">Sales Lead/Customer Lead (Booster, Subscription, Expert Assist)</option>
              <option value="3">Technical Support</option>
              <option value="4">New User</option>
              <option value="5">Payment Alert</option>
              <option value="6">Chargeback</option>
              <option value="7">Expert Assist Documents</option>
              <option value="8">Letters Overdue</option>
              <option value="9">Letters Unsent</option>
              <option value="10">Credit Repair Inquiry</option>
              <option value="11">Credit Score/Report Inquiry</option>
            </select>
          </div>
        </div>

        <div class="col-6 send-request">
          <div class="form-group">
            <label>Send Request to </label>
            <ngx-select [items]="_shared.getAdminList()" optionValueField="admin_id" optionTextField="admin_name"
              (select)="selectAdmin($event)" [allowClear]="true" (selectionChanges)="adminClear($event)"
              [placeholder]="notes.assigned_name || 'please enter send request to'">
              <ng-template ngx-select-option-selected let-option>
                {{option.data.admin_name }}
              </ng-template>
              <ng-template ngx-select-option let-option let-text="text">
                {{option.data.admin_name}} <br>
                <small>{{option.data.admin_email}}</small>
              </ng-template>
              <ng-template ngx-select-option-not-found>
                Not found
              </ng-template>
            </ngx-select>


          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="form-group">
            <label>
              Priority*
              <i class="ml-1 fa fa-info-circle" tooltip="Set the priority for the note."></i>
            </label>
            <select [(ngModel)]="notes.priority" required class="form-control" name="priority">
              <option value="1">Low</option>
              <option value="2">Medium</option>
              <option value="3">High</option>
            </select>
          </div>
        </div>

        <div class="col-6 mb-3 " *ngIf="notes.status!=2">
          <label>Followup Date*</label>
          <div class="input-group">
            <input readonly type="text" #dp="bsDatepicker" bsDatepicker class="form-control" name="followupDate"
              [(ngModel)]="notes.followup_date" [minDate]="minDate" required [bsConfig]="bsConfig"
              placeholder="MM/DD/YYYY">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary rounded-0" (click)="dp.toggle()" [attr.aria-expanded]="dp.isOpen"
                type="button"><i class="fa fa-calendar"></i></button>
            </div>
          </div>
        </div>
        <div class="col-6 follow-up" *ngIf="notes.status!=2">
          <label>Followup Time({{timezoneName}})*
            <i class="ml-1 fa fa-info-circle" tooltip="Please set followup time in 24 hour format."></i>
          </label>
          <div class="row followup-inner">
            <div class="col-6">
              <ngx-select [items]="hours" optionValueField="value" optionTextField="value" name="value"
                [allowClear]="false" placeholder="HH" [(ngModel)]="notes.followup_hour">
                <ng-template ngx-select-option-selected let-option>
                  {{option.data.value}}
                </ng-template>
                <ng-template ngx-select-option-not-found>
                  Not found
                </ng-template>
              </ngx-select>
            </div>
            <div class="col-6">
              <ngx-select [items]="minutes" optionValueField="value" optionTextField="value" name="value"
                [allowClear]="false" placeholder="MM" [(ngModel)]="notes.followup_minutes">
                <ng-template ngx-select-option-selected let-option>
                  {{option.data.value}}
                </ng-template>
                <ng-template ngx-select-option-not-found>
                  Not found
                </ng-template>
              </ngx-select>
            </div>
          </div>
        </div>
        <div class="w-100 my-1"></div>
        <div class="col-12 mb-3">
          <div class="form-group">
            <label>Notes*</label>
            <textarea required name="notes" [(ngModel)]="note" class="form-control" placeholder="Enter notes here"
              rows="4"></textarea>
          </div>
        </div>
        <div class="w-100 my-1"></div>
        <div class="col-6 mb-3">
          <div class="row px-1">
            <div>
              <label>Customer's feeling towards Recuvery</label>
            </div>
            <div class="w-100"></div>
            <div class="d-flex">
              <a href="javascript:void(0)" (click)="selectMood(1)" class="text-muted"
                [ngClass]="{'text-success':notes.customer_feedback == 1}">
                <i class="fa fa-smile fa-3x" tooltip="Happy"></i>
              </a>
              <a href="javascript:void(0)" (click)="selectMood(2)" class="text-muted mx-2"
                [ngClass]="{'text-warning':notes.customer_feedback == 2}">
                <i class="fa fa-frown fa-3x" tooltip="Angry"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="text-right">
            <label>Only png,jpg,jpeg and pdf format allowed !</label>
            <label for="images" class="btn btn-s btn-sm rounded attach-image">Attach Image/Document</label>
            <input type="file" name="" id="images" #imageElement accept=".jpeg, .jpg, .png, application/pdf"
              (change)="fileSelect($event)" class="d-none">
          </div>

          <div *ngFor="let file of images; let i=index">
            <div *ngIf="file.subs && file.subs[0]">
              <div class="d-flex" *ngIf="file.subs[0].message">
                <progressbar [value]="file.subs[0].message" type="warning" [striped]="true">
                  {{file.subs[0].message}}%</progressbar>
                <i class="fa fa-close ml-2" tappable tooltip="Cancel upload" (click)="cancelImageUpload(file, i)"></i>
              </div>


              <div *ngIf="file.subs[0].images && file.subs[0].images[0]"
                class="d-flex justify-content-between align-items-center border mb-1">
                <span>
                  <i class="fa fa-trash text-danger mr-2" (click)="deletFile(file.image, i)"
                    tooltip="Delete uploaded file" tappable></i>
                  <a [href]="file.image" target="_blank">Click here to view</a>
                </span>
                <i class="fa fa-check text-success" tooltip="File Uploaded"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div>
        <button type="submit" class="btn btn-s" [disabled]="notesForm.invalid">Add</button>
      </div>
    </div>
  </form>
</div>